export const workspaceKey_Page_SmartDocs = 'workspace__editor__smart-docs';
export const WorkspaceConfig_Page_SmartDocs = {
    name: workspaceKey_Page_SmartDocs,
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            { name: 'LeftPanel', key: 'list', visible: true, factor: 1.5 / 5, min: 450, data: {} },
            { name: 'RightPanel', key: 'editor', visible: true, factor: 3.5 / 5, min: 1100, data: {} },
        ]
    }
};
//# sourceMappingURL=workspace.js.map